<div class="white-label-container">
  <div class="white-label-form-section">
    <div class="white-label-form-section-header">
      <div class="white-label-form-section-header-title">
        <h2>WP Admin white labeling</h2>
        <p class="white-label-form-section-description">Customize your clients’ WP Admin with your own brand name and logo.</p>
      </div>
      <div class="white-label-form-section-header-actions">
        <button class="ds-btn-black" (click)="saveWhiteLabel()" [disabled]="loading" [class.ds-btn-disabled]="loading">
          <span *ngIf="!loading">Save</span>
          <img src="../../../assets/images/loading/spinner-dotted-white.svg" class="ds-input-loader" *ngIf="loading"/>
        </button>
      </div>
    </div>
    <div class="white-label-form-section-hint">
      These changes apply to all {{currentSubscription?.boosterCategory === UserSubscriptionCategory.AGENCY ? 'hosted ' : ''}}websites created under this account.
    </div>
    <div class="white-label__group-upload-logo">
      <div class="white-label__group-upload-logo-company" [ngStyle]="!defaultLogo && {'background-image': 'url(&quot;'+ (selectedImage && !defaultLogo ? selectedImage : '&quot;none&quot;') + '&quot;)'}" [class.error]="formSubmitted && (defaultLogo && !selectedImage && whiteLabelForm.valid)">
        <i class="db-icon db-icon-ds-logo-black" *ngIf="defaultLogo"></i>
        <i class="db-icon db-icon-ds-close-small-arrow" *ngIf="!defaultLogo" (click)="useDefaultLogo()"></i>
      </div>
      <div>
        <div class="white-label__upload">
          <span class="white-label__upload-label">Organization Logo</span>
          <a>
            <input type="file" name="cacheIcon" (change)="onFileChanged($event)" accept=".png,.jpg,.jpeg,.gif,.webp" id="uploadImage">
            <span>Upload logo</span>
          </a>
        </div>
      </div>
    </div>
    <p class="white-label__group-upload-logo-desc error" *ngIf="formSubmitted && (defaultLogo && !selectedImage && whiteLabelForm.valid)">You have already filled organization name. Organization logo is required</p>
    <p class="white-label__group-upload-logo-desc">Recommended: 256×256px, transparent PNG.<br/>If no logo is uploaded, the “10Web" logo will be used by default.</p>

    <form [formGroup]="whiteLabelForm" class="webhook-form">
      <div class="form-group">
        <div class="ds-input-wrap">
          <span class="ds-input-label">Organization name</span>
          <input
            (input)="formSubmitted = false"
            type="text"
            id="companyName"
            class="ds-input"
            formControlName="companyName"
            [placeholder]="'text_enterYourOrganizationName' | dbText"
          [class.is-invalid]="whiteLabelForm.get('companyName')?.errors?.required && whiteLabelForm.get('companyName')?.touched">
          <span class="ds-input-desc">{{'text_ifYouDontEnterAnythingDefault' | dbText}}</span>
          <span class="ds-input-error-msg" *ngIf="whiteLabelForm?.controls?.companyName?.errors?.required && formSubmitted
          && selectedImage">{{'text_logoUploadedOrgNameRequired' | dbText}}</span>
        </div>
      </div>
    </form>
  </div>
</div>
